import React,{useState,useEffect,useCallback} from 'react'
import { Hero } from "shared/components/bulma/hero";
import { sortArrayPipe } from "shared/pipes";
import { v4 as uuidv4 } from 'uuid';
import { create, deleteTypeofGarmentById, getTypeofGarments } from 'controllers/TypeOfGarments';
import TableComponent from 'components/table/Table';
import AddComponent from 'components/table/AddComponent';



function Garments() {
  const [inputText, setInputText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const [data, setData] = useState([]);
  
    const handleChange = (event) => {
        setInputText(event.target.value);
      };
    
  const handleClick = () => {
    const id = uuidv4()
    if (inputText) {
      create({ id:id,value: inputText, label: inputText },setData,inputText,setInputText,id,setIsLoading,isLoading)
    }

  };
  
async function dataStream(callback) {

  const typeofgarment = await getTypeofGarments();
  callback(sortArrayPipe.transform(typeofgarment, 'value'));
  }
  const cachedFn = useCallback( async() => {    
      await dataStream((values) => {
        setData(values)
    });
  },[])
  
  useEffect( () => {
    cachedFn()
  },[cachedFn])
  const HandleDelete = (id) => {
    deleteTypeofGarmentById(id,setData,isDeleting, setIsDeleting)
    };
    return (
      <>
      <div style={{display:'flex',justifyContent:'center',marginTop:'2%'}}>
          <AddComponent
            label="Add Garment Type"
            buttonlabel="Add Category"
            inputText={inputText}
            handleClick={handleClick}
            handleChange={handleChange}
            placeholder="New Category"/>
      </div>
            <Hero>
          <TableComponent
            data={data}
            HandleDelete={HandleDelete}
            updateUrl="update-garment"
          
          />
            </Hero>
            </>
  )
}

export default Garments;